import {
  type CreateOrderDTO,
  type GetAllOrdersDTO,
  type OrderModel,
  type OrderRepository,
  UpdateOrderDTO
} from '@trading/core'
import axios from '../axios'
import type { GetOrderDTO } from "@trading/core";
import { NotFoundError } from "../errorTypes";

export class OrderApiAxios implements OrderRepository {
  public get(dto: GetOrderDTO): Promise<OrderModel[]> {
    throw new Error('Method not implemented.')
  }

  async getAll(dto: GetAllOrdersDTO) {
    return await axios
      .get<{ data: { orders: OrderModel[] } }>(`trading/orders`, {
        params: dto,
      })
      .then((resp) => resp.data.data.orders)
    // .catch((e: unknown) => {
    //   if (e instanceof NotFoundError) {
    //     showToast('${} не найден');
    //     throw e
    //   }
    //   else if (e instanceof AuthError) redirectToLogin();
    //   throw new Error(e)
    // })
  }

  async create(dto: CreateOrderDTO): Promise<OrderModel> {
    return await axios
      .post<{ order: OrderModel }>(`trading/orders`, dto, {
        metadataDescription: {
          item: 'Order',
          action: 'Create'
        }
      })
      .then((resp) => resp.data.order)
      .catch((e) => {
        throw new Error(e)
      })
  }

  async update(dto: UpdateOrderDTO, id: number): Promise<OrderModel> {
    return await axios
      .patch(`trading/orders/${id}`, dto, {
        metadataDescription: {
          item: 'Order',
          action: 'Update'
        }
      })
      .then((resp) => resp.data.order)
      .catch((e) => {
        throw new Error(e)
      })
  }

  async delete(id: ID): Promise<void> {
    return await axios
      .delete(`trading/orders/${id}`)
      .then(() => {
      })
      .catch((e) => {
        throw new Error(e)
      })
  }

  async deleteBySymbol(symbol: string): Promise<number> {
    return await axios
      .delete<{ data: { cancelled_count: number } }>('trading/orders', {
        params: {symbol}
      })
      .then((resp) => resp.data.data.cancelled_count)
  }
}
